module.exports = function (THREE) {
  function f1130(p7632) {
    if (v6396 !== p7632) {
      if (p7632.isChild) {
        const v6370 = (p7632.parentIndex > -1 ? p7632.parent._children[p7632.parentIndex] : p7632.parent).matrixWorld;
        if (v6378.getInverse) {
          v6378.getInverse(v6370);
        } else {
          v6378.copy(v6370).invert();
        }
        v6378.multiply(p7632.matrixWorld);
      } else {
        v6378.copy(p7632.matrixWorld);
      }
      v6378.decompose(v6374, v6376, v6375);
      v6396 = null;
      v6379._x = v6374.x;
      v6379._y = v6374.y;
      v6379._z = v6374.z;
      v6382.x = v6376.x;
      v6382.y = v6376.y;
      v6382.z = v6376.z;
      v6382.w = v6376.w;
      v6380._x = v6375.x;
      v6380._y = v6375.y;
      v6380._z = v6375.z;
      v6396 = p7632;
    }
  }
  THREE.Frustum.prototype.intersectsObject = function () {
    const v6371 = new THREE.Sphere();
    const vA348 = [];
    return function (p7633) {
      const v6372 = p7633.geometry;
      if (v6372.boundingSphere === null) {
        v6372.computeBoundingSphere();
      }
      if (p7633.isStatic) {
        if (p7633.isChild && p7633.parent.compound) {
          return p7633.parent._visible;
        } else {
          v6371.radius = p7633.radius;
          v6371.center.copy(p7633);
          p7633._visible = this.intersectsSphere(v6371);
          this.children = !p7633.visible && p7633.compound ? vA348 : this._children;
          return p7633._visible;
        }
      } else {
        v6371.copy(v6372.boundingSphere).applyMatrix4(p7633.matrixWorld);
        return this.intersectsSphere(v6371);
      }
    };
  }();
  let v6373 = -1;
  const v6374 = new THREE.Vector3();
  const v6375 = new THREE.Vector3();
  const v6376 = new THREE.Quaternion();
  const v6377 = new THREE.Box3();
  const v6378 = new THREE.Matrix4();
  const v6379 = new THREE.Vector3();
  const v6380 = new THREE.Vector3();
  const v6381 = new THREE.Euler();
  const v6382 = new THREE.Quaternion();
  THREE.StaticMesh = function (p7634, p7635) {
    this.id = v6373--;
    this.index = 0;
    this.parentIndex = 0;
    this.x = 0;
    this.y = 0;
    this.z = 0;
    this.radius = 0;
    this.matrixWorld = new THREE.Matrix4();
    this.parent = p7635 || null;
    this.isChild = !!p7635;
    if (p7634) {
      this.setSource(p7634);
    }
  };
  THREE.StaticMesh.prototype = {
    ...THREE.Object3D.prototype,
    ...THREE.Mesh.prototype,
    ...THREE.EventDispatcher.prototype,
    updateMorphTargets: THREE.Mesh.prototype.updateMorphTargets,
    onBeforeRender: THREE.Mesh.prototype.onBeforeRender,
    onAfterRender: THREE.Mesh.prototype.onAfterRender,
    addEventListener: THREE.EventDispatcher.prototype.addEventListener,
    removeEventListener: THREE.EventDispatcher.prototype.removeEventListener,
    dispatchEvent: THREE.EventDispatcher.prototype.dispatchEvent,
    getObjectByName: THREE.Object3D.prototype.getObjectByName,
    getObjectByProperty: THREE.Object3D.prototype.getObjectByProperty,
    getObjectById: THREE.Object3D.prototype.getObjectById,
    constructor: THREE.StaticMesh,
    isObject3D: true,
    isMesh: false,
    isStatic: true,
    isChild: false,
    visible: true,
    compound: true,
    uuid: "",
    name: "",
    type: "StaticMesh",
    children: [],
    _visible: true,
    _children: [],
    frustumCulled: true,
    renderOrder: 0,
    castShadow: false,
    receiveShadow: false,
    matrixAutoUpdate: false,
    layers: new THREE.Layers(),
    modelViewMatrix: new THREE.Matrix4(),
    normalMatrix: new THREE.Matrix3(),
    matrix: new THREE.Matrix4(),
    up: THREE.Object3D.DEFAULT_UP.clone(),
    restore: function (p7636) {
      if (this.isChild) {
        console.error("Trying to restore from a child");
        return null;
      } else {
        p7636 = p7636 || this.source;
        let v6383 = -1;
        const vThis48 = this;
        p7636.matrixWorld.copy(this.matrixWorld);
        p7636.matrix.copy(this.matrixWorld);
        this.matrixWorld.decompose(p7636.position, p7636.quaternion, p7636.scale);
        p7636.traverse(p7637 => {
          if (v6383 > -1) {
            const v6384 = vThis48._children[v6383];
            const v6385 = v6384.parentIndex > -1 ? vThis48._children[v6384.parentIndex] : vThis48;
            v6378.copy(v6385.matrixWorld).invert();
            v6378.multiply(v6384.matrixWorld);
            p7637.matrixWorld.copy(v6384.matrixWorld);
            p7637.matrix.copy(v6378);
            v6378.decompose(p7637.position, p7637.quaternion, p7637.scale);
          }
          v6383++;
        });
        return p7636;
      }
    },
    save: function () {
      const v6386 = this.source;
      let v6387 = -1;
      const vThis49 = this;
      if (v6386.matrixAutoUpdate !== true) {
        v6386.updateMatrix();
      }
      v6386.updateMatrixWorld(true);
      v6386.traverse(p7638 => {
        if (v6387 > -1) {
          const v6388 = vThis49._children[v6387];
          v6388.matrixWorld.copy(p7638.matrixWorld);
          if (!v6386.compound && v6388.geometry) {
            if (!v6388.geometry.boundingSphere) {
              v6388.geometry.computeBoundingSphere();
            }
            const v6389 = v6388.geometry.boundingSphere;
            v6388.radius = v6388.matrixWorld.getMaxScaleOnAxis() * v6389.radius;
            v6374.copy(v6389.center).applyMatrix4(v6388.matrixWorld);
            v6388.x = v6374.x;
            v6388.y = v6374.y;
            v6388.z = v6374.z;
          }
        }
        v6387++;
      });
      this.matrixWorld.copy(v6386.matrixWorld);
      if (this.compound && this.children.length) {
        this.computeBoundingSphere();
      }
      this.update();
    },
    update: function () {
      const v6390 = this.source.boundingSphere ? this.source : this.geometry;
      if (!v6390.boundingSphere) {
        v6390.computeBoundingSphere();
      }
      this.radius = this.matrixWorld.getMaxScaleOnAxis() * v6390.boundingSphere.radius;
      v6374.copy(v6390.boundingSphere.center).applyMatrix4(this.matrixWorld);
      this.x = v6374.x;
      this.y = v6374.y;
      this.z = v6374.z;
    },
    composeMatrix: function () {
      if (this.isChild) {
        this.parent.restore();
        this.source.position.set(v6379._x, v6379._y, v6379._z);
        this.source.quaternion.set(v6382._x, v6382._y, v6382._z, v6382._w);
        this.source.scale.set(v6380._x, v6380._y, v6380._z);
        this.parent.save();
      } else if (this.children.length) {
        this.restore();
        this.matrixWorld.compose(v6379, v6382, v6380);
        this.source.position.set(v6379._x, v6379._y, v6379._z);
        this.source.quaternion.set(v6382._x, v6382._y, v6382._z, v6382._w);
        this.source.scale.set(v6380._x, v6380._y, v6380._z);
        this.save();
      } else {
        this.matrixWorld.compose(v6379, v6382, v6380);
        this.update();
      }
    },
    computeBoundingSphere: function () {
      const v6391 = this.source;
      const v6392 = v6391.boundingSphere || new THREE.Sphere();
      v6391.updateMatrix();
      v6378.copy(v6391.matrix);
      v6391.position.set(0, 0, 0);
      v6391.scale.set(1, 1, 1);
      v6391.quaternion.set(0, 0, 0, 1);
      v6391.updateMatrixWorld(true);
      v6377.expandByObject(v6391);
      v6377.max.divideScalar(2);
      v6392.center.copy(v6377.max);
      v6392.radius = Math.sqrt(v6377.min.distanceToSquared(v6377.max));
      v6378.decompose(v6391.position, v6391.quaternion, v6391.scale);
      v6391.updateMatrixWorld(true);
      v6391.boundingSphere = v6392;
    },
    setSource: function (p7639) {
      this.source = p7639;
      this.geometry = p7639.geometry;
      this.material = p7639.material;
      if (p7639.used === undefined) {
        p7639.used = 0;
      }
      p7639.used++;
      if (p7639.isMesh) {
        this.isMesh = true;
        this.isSkinnedMesh = false;
        this.updateMorphTargets();
      }
      if (p7639.isSkinnedMesh) {
        this.isMesh = false;
        this.isSkinnedMesh = true;
        this.skeleton = p7639.skeleton;
        this.bindMatrix = p7639.bindMatrix;
        this.bindMatrixInverse = p7639.bindMatrixInverse;
        this.updateMatrixWorld = p7639.updateMatrixWorld;
      }
      if (!this.isChild) {
        if (p7639.children.length) {
          let vLN01024 = 0;
          const vThis50 = this;
          this.children = [];
          this._children = this.children;
          p7639.updateMatrixWorld(true);
          p7639.index = -1;
          p7639.traverse(p7640 => {
            if (vLN01024 > 0) {
              const v6393 = new THREE.StaticMesh(p7640, vThis50);
              p7640.index = vLN01024 - 1;
              v6393.parentIndex = p7640.parent.index;
              vThis50.children.push(v6393);
            }
            vLN01024++;
          });
        } else if (this.children !== this.constructor.prototype.children) {
          delete this.children;
          delete this._children;
        }
        this.save();
      } else {
        this.matrixWorld.copy(p7639.matrixWorld);
      }
    },
    updateMatrixWorld: function () {},
    updateWorldMatrix: function () {},
    traverse: function (p7641) {
      p7641(this);
      const v6394 = this._children;
      for (let vLN01025 = 0, v6395 = v6394.length; vLN01025 < v6395; vLN01025++) {
        v6394[vLN01025].traverse(p7641);
      }
    },
    add: function () {
      console.error("Objects can't be added to static meshes");
    },
    remove: function () {
      console.error("Objects can't be removed from static meshes");
    }
  };
  let v6396;
  v6379._x = 0;
  v6379._y = 0;
  v6379._z = 0;
  Object.defineProperties(v6379, {
    x: {
      set: function (p7642) {
        v6379._x = p7642;
        v6396.composeMatrix();
      },
      get: function () {
        return v6379._x;
      }
    },
    y: {
      set: function (p7643) {
        v6379._y = p7643;
        v6396.composeMatrix();
      },
      get: function () {
        return v6379._y;
      }
    },
    z: {
      set: function (p7644) {
        v6379._z = p7644;
        v6396.composeMatrix();
      },
      get: function () {
        return v6379._z;
      }
    }
  });
  v6380._x = 0;
  v6380._y = 0;
  v6380._z = 0;
  Object.defineProperties(v6380, {
    x: {
      set: function (p7645) {
        this._x = p7645;
        v6396.composeMatrix();
      },
      get: function () {
        return this._x;
      }
    },
    y: {
      set: function (p7646) {
        this._y = p7646;
        v6396.composeMatrix();
      },
      get: function () {
        return this._y;
      }
    },
    z: {
      set: function (p7647) {
        this._z = p7647;
        v6396.composeMatrix();
      },
      get: function () {
        return this._z;
      }
    }
  });
  v6381._onChangeCallback = function () {
    v6382.setFromEuler(v6381, false);
    if (v6396) {
      v6396.composeMatrix();
    }
  };
  v6382._onChangeCallback = function () {
    v6381.setFromQuaternion(v6382, undefined, false);
    if (v6396) {
      v6396.composeMatrix();
    }
  };
  Object.defineProperties(THREE.StaticMesh.prototype, {
    position: {
      get: function () {
        f1130(this);
        return v6379;
      }
    },
    rotation: {
      get: function () {
        f1130(this);
        return v6381;
      }
    },
    quaternion: {
      get: function () {
        f1130(this);
        return v6382;
      }
    },
    scale: {
      get: function () {
        f1130(this);
        return v6380;
      }
    }
  });
  THREE.Mesh.prototype.toStatic = function () {
    return new THREE.StaticMesh(this);
  };
};